const FIRST_NAMES = [
  'Ana', 'Bruno', 'Carla', 'Daniel', 'Eduarda', 'Felipe', 'Gabriela',
  'Henrique', 'Isabela', 'João', 'Larissa', 'Marcos', 'Natália', 'Otávio',
  'Patrícia', 'Rafael', 'Sabrina', 'Thiago', 'Vanessa', 'William',
]

const LAST_NAMES = [
  'Silva', 'Santos', 'Oliveira', 'Souza', 'Pereira', 'Costa', 'Rodrigues',
  'Almeida', 'Nascimento', 'Lima', 'Araújo', 'Fernandes', 'Carvalho',
  'Gomes', 'Martins', 'Ribeiro', 'Barbosa', 'Rocha', 'Dias', 'Teixeira',
]

const STREET_NAMES = [
  'Rua das Flores', 'Avenida Brasil', 'Rua Sete de Setembro',
  'Rua XV de Novembro', 'Avenida Paulista', 'Rua Rio Branco',
  'Rua Tiradentes', 'Avenida das Nações', 'Rua São José', 'Rua da Paz',
]

const CITIES = [
  ['São Paulo', 'SP'], ['Rio de Janeiro', 'RJ'], ['Belo Horizonte', 'MG'],
  ['Salvador', 'BA'], ['Curitiba', 'PR'], ['Fortaleza', 'CE'],
  ['Recife', 'PE'], ['Porto Alegre', 'RS'], ['Balsas', 'MA'],
  ['Manaus', 'AM'],
]

const EMAIL_DOMAINS = ['exemplo.com', 'teste.dev', 'mail.test', 'ficticio.com.br']

const randomFrom = (list) => list[Math.floor(Math.random() * list.length)]
const randomInt = (min, max) =>
  Math.floor(Math.random() * (max - min + 1)) + min

const normalize = (text) =>
  text
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()

export const generateFakePerson = () => {
  const firstName = randomFrom(FIRST_NAMES)
  const lastName = randomFrom(LAST_NAMES)
  const [city, state] = randomFrom(CITIES)
  const ddd = randomInt(11, 99)

  return {
    name: `${firstName} ${lastName}`,
    email: `${normalize(firstName)}.${normalize(lastName)}${randomInt(1, 99)}@${randomFrom(EMAIL_DOMAINS)}`,
    phone: `(${ddd}) 9${randomInt(1000, 9999)}-${randomInt(1000, 9999)}`,
    address: `${randomFrom(STREET_NAMES)}, ${randomInt(10, 2000)}  ${city}/${state}`,
  }
}
